
import { mapGetters, mapState, mapActions } from 'vuex';
import TransitionFadeHeight from '@/transitions/TransitionFadeHeight';
import ReviewContentType from '@/enums/ReviewContentType';
import BoardShowReviewInfoOption from '@/enums/BoardShowReviewInfoOption';
import DropdownMenuWidth from '@/enums/DropdownMenuWidth';
import AuthorGrade from '@/enums/AuthorGrade';
import AppReviewUserInfoSectionUserDisplay from '@/components/common/AppReviewUserInfoSection/AppReviewUserInfoSectionUserDisplay.vue';
import AppReviewEvaluationTypeOptions from '@/components/common/AppReviewEvaluationTypeOptions.vue';

export default {
  i18nComponentKey: 'WidgetProductReviewsBoard.components.ReviewBoardPc',
  name: 'ReviewBoardPc',
  components: {
    TransitionFadeHeight,
    AppReviewUserInfoSectionUserDisplay,
    AppReviewEvaluationTypeOptions
  },
  props: {
    review: {
      type: Object,
      required: true
    },
    reviewIndex: { type: Number, required: true },
    popupParams: { type: Object, required: true }
  },
  data() {
    return {
      collapsed: true,
      hovered: false
    };
  },
  computed: {
    ...mapState('widget', ['widget']),
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapGetters('widget', ['device']),
    ...mapGetters('review', [
      'isManagerReview',
      'showEditOrDelete',
      'showScore',
      'showDate'
    ]),
    ...mapGetters('reviewSettings', [
      'isAuthorDisplayTypeUserGrade',
      'isAuthorDisplayTypeAuthorType'
    ]),
    DropdownMenuWidth: () => DropdownMenuWidth,
    userReviewOption() {
      if (this.isAuthorDisplayTypeUserGrade && this.review.brand_user_grade) {
        return {
          name: this.$t('user_grade'),
          value: this.review.brand_user_grade.name
        };
      }

      if (this.isAuthorDisplayTypeAuthorType && this.review.brand_author_type) {
        return {
          name: this.$t('author_grade'),
          value: this.review.brand_author_type.title
        };
      }

      if (this.isAuthorDisplayTypeAuthorType && this.review.author_grade) {
        return {
          name: this.$t('author_grade'),
          value: AuthorGrade.t(this.review.author_grade)
        };
      }

      return null;
    },
    toggleIconTitle() {
      return this.collapsed ? this.$t('closed') : this.$t('open');
    },
    shouldDisplayThumbnailOnCollapsed() {
      return (
        (this.widget.board_show_review_info_option &
          BoardShowReviewInfoOption.SHOW_THUMBNAIL) >
          0 &&
        (this.review.images.length > 0 || this.review.videos.length > 0)
      );
    }
  },
  methods: {
    ...mapActions('review', ['handleEditOrDeleteReview']),
    clickMessageToggle() {
      this.collapsed = !this.collapsed;
    },
    shouldDisplayReviewOptions(review) {
      return (
        !!review.customer_properties && review.customer_properties.length > 0
      );
    },
    shouldDisplayEvaluationProperties(review) {
      return (
        !!review.evaluation_properties &&
        review.evaluation_properties.length > 0
      );
    },
    shouldDisplayProductOptions(review) {
      return (
        this.reviewSettings.show_options && review.product_options.length > 0
      );
    },
    shouldDisplayMediaSection(review) {
      return (
        review.content_type !== ReviewContentType.RESTRICTED &&
        (review.images.length > 0 || review.videos.length > 0)
      );
    },
    mouseover({ target }) {
      if (target.closest('.AppReviewInfoSectionBoard__review_edit_or_delete')) {
        this.hovered = false;
      } else {
        this.hovered = true;
      }
    },
    mouseout() {
      this.hovered = false;
    },
    editOrDeleteOptions(review) {
      return [
        review.editable
          ? { name: this.$t('app.edit_review'), value: 'edit' }
          : null,
        review.deletable
          ? {
              name: this.$t('app.delete_review'),
              value: 'delete',
              danger: true
            }
          : null
      ].filter(v => v);
    },
    shouldDisplayScoreOnExpanded(review) {
      return (
        this.showScore(review) &&
        (this.widget.board_show_review_info_option &
          BoardShowReviewInfoOption.SHOW_SCORE) ===
          0
      );
    },
    shouldDisplayDateOnExpanded(review) {
      return (
        this.showDate(review) &&
        (this.widget.board_show_review_info_option &
          BoardShowReviewInfoOption.SHOW_CREATED_AT) ===
          0
      );
    }
  }
};
